module.exports = __webpack_public_path__ + "img/my-marker.8bb99330.png";